import { createStore } from 'satcheljs';
export default createStore('weatherOption', {
    weatherEnabled: null,
    weatherUnit: null,
});
//# sourceMappingURL=store.js.map